import React, {
  Fragment,
  useEffect,
  useState,
  useContext,
  useCallback,
  useRef,
} from "react";
import { FiChevronRight } from "react-icons/fi";
import { Link } from "react-router-dom";
import axios from "axios";
import { withLang } from "../../../utils/langLink";
import { getMenuList } from "../../../utils/fackData/menuList";
import getIcon from "../../../utils/getIcon";
import useTranslations from "../../../hooks/useTranslations";
import useUserLanguage from "../../../hooks/useUserLanguage";
import { NavigationContext } from "../../../contentApi/navigationProvider";
import usePermissionList from "../../../hooks/usePermissionList";

import "./Menus.css";

export default function Menus() {
  /* -------- state -------- */
  const [modules, setModules] = useState([]);
  const [visibleKeys, setVisible] = useState([]);
  const [menuList, setMenuList] = useState([]);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [openSub, setOpenSub] = useState(null);

  const {
    navigationExpend,
    activeParent,
    setActiveParent,
    activeChild,
    setActiveChild,
  } = useContext(NavigationContext);

  const permissions = usePermissionList();
  const lang = useUserLanguage();
  const { translations } = useTranslations(lang);
  const getText = useCallback((k, d) => translations[k] || d, [translations]);

  useEffect(() => {
    (async () => {
      try {
        const token = localStorage.getItem("admin_token");
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/modules`,
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );
        setModules(data);
        localStorage.setItem("modules", JSON.stringify(data));
        console.log("%c[MOD] Sunucudan gelen modules:", "color:orchid", data);
      } catch (err) {
        console.error("Modüller alınamadı:", err);
      }
    })();
  }, []);
  useEffect(() => {
    const handler = (e) => setModules(e.detail); // e.detail == fresh list
    window.addEventListener("modulesUpdated", handler);
    return () => window.removeEventListener("modulesUpdated", handler);
  }, []);
  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/permissions/visible-keys`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
            },
          },
        );
        console.log("🟨 Görünür Menü Anahtarları (visibleKeys):", visibleKeys);
        console.log("%c[VIS] visibleKeys:", "color:orange", data);
        setVisible(Array.isArray(data) ? data : []);
      } catch (e) {
        console.error("visibleKeys alınamadı ➜", e);
      }
    })();
  }, []);

  useEffect(() => {
    // tüm bağımlılıklar hazırsa…
    if (!translations || !permissions.length) return;

    const roleId =
      +(localStorage.getItem("role_id") || sessionStorage.getItem("role_id")) ||
      null;
    console.log("%c[ML] parametreler:", "color:lime", {
      tKeys: Object.keys(translations).length,
      permissions,
      modules,
      roleId,
      visibleKeys,
    });

    (async () => {
      const list = getMenuList(
        getText,
        permissions,
        modules,
        roleId,
        visibleKeys,
      );
      console.log("🧪 getMenuList sonucu:", list); // 👈 bunu ekle
      console.log("%c[ML] getMenuList ➜ fullMenu:", "color:lime", list);
      setMenuList(list); // artık kesin Array
    })();
  }, [modules, permissions, visibleKeys, translations, getText]);

  useEffect(() => {
    if (!activeParent && menuList.length) {
      setActiveParent(menuList[0].name);
    }
  }, [menuList, activeParent, setActiveParent]);

  const lastOpenDropdown = useRef(null);
  const lastOpenSub = useRef(null);

  useEffect(() => {
    if (navigationExpend) {
      lastOpenDropdown.current = openDropdown;
      lastOpenSub.current = openSub;
    }
  }, [navigationExpend, openDropdown, openSub]);

  useEffect(() => {
    if (!navigationExpend) {
      setOpenDropdown(null);
      setOpenSub(null);
    } else {
      setOpenDropdown(lastOpenDropdown.current);
      setOpenSub(lastOpenSub.current);
    }
  }, [navigationExpend]);

  const handleMain = (e, item) => {
    if (!navigationExpend) return;
    if (item.dropdownMenu?.length) {
      e.preventDefault();
      setOpenDropdown(openDropdown === item.name ? null : item.name);
      setOpenSub(null);
    } else {
      setOpenDropdown(null);
      setActiveParent(item.name);
      setActiveChild("");
    }
  };

  const handleSub = (e, sub, parent) => {
    if (!navigationExpend) return;
    if (sub.subdropdownMenu?.length) {
      e.preventDefault();
      setOpenSub(openSub === sub.name ? null : sub.name);
    } else {
      setActiveParent(parent);
      setActiveChild(sub.name);
    }
  };

  return (
    <>
      {menuList.map((item, idx) =>
        item.isDivider ? (
          <hr key={`div-${idx}`} className="menu-divider" />
        ) : (
          <li
            key={item.id || idx}
            className={`nxl-item ${
              activeParent === item.name ? "active nxl-trigger" : ""
            }`}
          >
            <Link
              to={withLang(item.path)}
              className="nxl-link"
              onClick={(e) => handleMain(e, item)}
            >
              <span className="nxl-micon">
                <img
                  src={`${process.env.PUBLIC_URL}/icons/svg/${item.icon || "default-icon.svg"}`}
                  alt={item.name}
                  style={{ width: 24, height: 24 }}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.replaceWith(getIcon(item.icon));
                  }}
                />
              </span>

              {navigationExpend && (
                <>
                  <span className="nxl-mtext text-capitalize">{item.name}</span>
                  {item.dropdownMenu?.length > 0 && (
                    <span className="nxl-arrow fs-16">
                      <FiChevronRight />
                    </span>
                  )}
                </>
              )}
            </Link>

            {/* Submenu */}
            {navigationExpend && item.dropdownMenu?.length > 0 && (
              <ul
                className={`nxl-submenu ${
                  openDropdown === item.name
                    ? "nxl-menu-visible"
                    : "nxl-menu-hidden"
                }`}
              >
                {item.dropdownMenu.map((sub) => (
                  <Fragment key={sub.id}>
                    {sub.subdropdownMenu?.length ? (
                      <li
                        className={`nxl-item ${
                          activeChild === sub.name ? "active" : ""
                        }`}
                      >
                        <Link
                          to={withLang(sub.path)}
                          className="nxl-link text-capitalize"
                          onClick={(e) => handleSub(e, sub, item.name)}
                        >
                          <span className="nxl-mtext">{sub.name}</span>
                          <span className="nxl-arrow">
                            <FiChevronRight />
                          </span>
                        </Link>

                        <ul
                          className={`nxl-submenu ${
                            openSub === sub.name
                              ? "nxl-menu-visible"
                              : "nxl-menu-hidden"
                          }`}
                        >
                          {sub.subdropdownMenu.map((ss) => (
                            <li
                              key={ss.id}
                              className={`nxl-item ${
                                activeChild === ss.name ? "active" : ""
                              }`}
                            >
                              <Link
                                className="nxl-link text-capitalize"
                                to={withLang(ss.path)}
                                onClick={() => {
                                  setActiveParent(item.name);
                                  setActiveChild(ss.name);
                                }}
                              >
                                {ss.name}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </li>
                    ) : (
                      <li
                        className={`nxl-item ${
                          activeChild === sub.name ? "active" : ""
                        }`}
                      >
                        <Link
                          to={withLang(sub.path)}
                          className="nxl-link"
                          onClick={(e) => handleSub(e, sub, item.name)}
                        >
                          {sub.name}
                        </Link>
                      </li>
                    )}
                  </Fragment>
                ))}
              </ul>
            )}
          </li>
        ),
      )}
    </>
  );
}
